import { render, staticRenderFns } from "./ManualsPage.vue?vue&type=template&id=2338ecb6&"
import script from "./ManualsPage.vue?vue&type=script&lang=ts&"
export * from "./ManualsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports